export default __webpack_public_path__ + "static/media/dig.ef65ca56.mp3";